
import {
  defineComponent,
} from '@vue/composition-api';
import { LinkButton } from '@fc/angie-ui';
import { isTabletUpEffect, isMobileEffect } from '~/effects/matchMedia';
import FCImage from '~/components/FCImage.vue';

export default defineComponent({
  name: 'ShopPackageCards',
  components: {
    LinkButton,
    FCImage,
  },
  props: {
    package: {
      type: Object,
      required: true,
    },
    defaultExpanded: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isTabletUp = isTabletUpEffect();
    const isMobile = isMobileEffect();

    // @ts-ignore
    const { $ecommAnalytics } = useNuxtApp();
    const toggle = () => {
      if (!isTabletUp.value) {
        emit('toggle');
        $ecommAnalytics.trackEvent('track_click', {
          track_click_name: `Shop_PackagesCards_Toggle_${props.package.title}`,
        });
      }
    };

    return {
      toggle,
      isTabletUp,
      isMobile,
    };
  },
});
